module.exports = __webpack_public_path__ + "fonts/icomoon.bba6f4a.eot";